'use client';

import styled from '@benzinga/themetron';

export const Text = styled.div<{ lines?: number }>`
  ${({ lines }) =>
    lines &&
    `
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: ${lines};
  `}
`;

export const Span = styled.div<{ lines?: number }>`
  ${({ lines }) =>
    lines &&
    `
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: ${lines};
  `}
`;
